<template>
  <b-form-group class="m-0">
    <b-button variant="light" size="sm" class="ml-3 pr-5 text-muted bg-white border" v-b-modal.algolia-search-modal>
      {{ trans('search') }}
    </b-button>
    <b-button variant="branded" size="sm" class="ml-2" v-b-modal.algolia-search-modal>
      <i class="fa fa-fw fa-search"></i>
    </b-button>
  </b-form-group>
</template>

<script>
  export default {
    data() {
      return {
        trans: trans,
      }
    },
  }
</script>